window.addEventListener("DOMContentLoaded", () => {
  if ($("#InscriptionForm").length) {
    $("select[name='dob'], select[name='mob'], select[name='yob']").change(function (e) {
      var dob = $("select[name='dob']").val();
      var mob = $("select[name='mob']").val();
      var yob = $("select[name='yob']").val();

      if (dob && mob && yob) {
        $("input[id='full_dob']").val("newsletter, dob:" + dob + "-" + mob + "-" + yob);
      }
    });
  }
});
